export default __webpack_public_path__ + "static/media/S-015.d2520e12.png";